export default {
  default: [
    {
      path: "/spaar-contract/aanmaken",
      name: "fundingContracts.create",
      component: () => import("./views/FundingContractFormView.vue")
    }
  ]
};
